import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { SiAppstore, SiGoogleplay } from "react-icons/si";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "left" }}>
          {props.description}
        </Card.Text>

        {props.ghLink && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            GitHub
          </Button>
        )}
        {"\n"}
        {"\n"}

        {props.iosLink && (
          <Button
            variant="primary"
            href={props.iosLink}
            target="_blank"
            style={{ marginLeft: "5px", whiteSpace: "nowrap" }}
          >
            <SiAppstore />&nbsp;
            App Store
          </Button>
        )}
        {"\n"}
        {"\n"}

        {props.googlePlayStoreLink && (
          <Button
            variant="primary"
            href={props.googlePlayStoreLink}
            target="_blank"
            style={{ marginLeft: "5px", whiteSpace: "nowrap" }}
          >
            <SiGoogleplay />&nbsp;
            Google Play
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
